(function () {
 function init() {
  const root=document.querySelector('.unico-custom,.unico-product');
  const bar=document.querySelector('[data-mobile-shortcut]');
  if(!root||!bar)return;
  const submit=root.querySelector('button[type="submit"]');
  const form=submit&&submit.closest('form');
  const button=bar.querySelector('[data-shortcut-button]');
  if(!submit||!form)return;
  let frame=null;
  const visible=el=>el&&el.getBoundingClientRect().width>0&&el.getBoundingClientRect().height>0&&getComputedStyle(el).visibility!=='hidden';
  function update(){
   frame=null;
   const busy=Array.from(document.querySelectorAll('dialog[open],[role="dialog"],[role="alertdialog"],.u-mobile-menu[open]')).some(visible);
   bar.hidden=busy;
   document.body.classList.toggle('unico-has-fixed-cart',!busy);
   const label=(submit.querySelector('[data-add-label]')||submit).textContent.trim().replace(/\s*[→↗]\s*$/,'');
   if(button.textContent!==label)button.textContent=label;
   button.disabled=submit.disabled;
  }
  function schedule(){if(!frame)frame=requestAnimationFrame(update);}
  button.addEventListener('click',()=>{if(!submit.disabled)submit.click();});
  window.addEventListener('resize',schedule,{passive:true});
  document.addEventListener('click',schedule);
  new MutationObserver(schedule).observe(root,{childList:true,characterData:true,subtree:true,attributes:true,attributeFilter:['hidden','disabled','aria-hidden','open','aria-pressed']});
  new MutationObserver(schedule).observe(document.body,{subtree:true,attributes:true,attributeFilter:['open','aria-hidden']});
  update();
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
